export default __webpack_public_path__ + "static/media/GES_B_WHITE.c8e3a3ff.png";